import { faEdit, faLock, faLockOpen, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useContext, useEffect, useState } from 'react';
import { Tooltip } from 'react-tooltip';
import { Handle, useReactFlow, useStoreApi, Position } from 'reactflow';
import AppContext from '../../../contexts/AppContext';

function Hazard({ id, data }) {
  const [lockedByUsername, setLockedByUsername] = useState(data.lockedByUsername)
  const [text, setText] = useState(data.text)
  const { user } = useContext(AppContext);
  const keys = Object.keys(data.handles);

  useEffect(()=>{
    setLockedByUsername(data.lockedByUsername)
  },[data.lockedByUsername])

  useEffect(()=>{
    setText(data.text)
  },[data.text])

  return (
    <>
      <div className="custom-node__header text-gray-100 bg-zinc-500 rounded-t-[15px] flex justify-between">
        <strong>Source of Risk</strong>
         <div className={`${lockedByUsername ? 'text-slate-700 bg-slate-100' : 'text-slate-300'} flex justify-between`}>
        {lockedByUsername ?
          <div><span className='text-sm  px-1 rounded'><FontAwesomeIcon icon={faLock} size='sm' /> <span className='ml-1'>{lockedByUsername == user?.sub ? 'You' : data.lockedByUsername}</span></span> </div>
          : <><div data-tooltip-content={'Edit/Lock'} data-tooltip-id='edit' onClick={async () => {
            const status = await data.acquireLock();
            if (status == 200) {
              setLockedByUsername(user.sub)
            }
          }} className='text-slate-300  ml-2 px-[4px] rounded cursor-pointer'>
            <FontAwesomeIcon icon={faEdit} size='sm' />
          </div>
            <Tooltip place='top' id='edit' /></>}

        {(lockedByUsername === user?.sub) &&
          <>
            <div data-tooltip-content={'Save'} data-tooltip-id='save' onClick={() => data.update(text)} className='text-teal-600 ml-2 px-[4px] rounded cursor-pointer'>
              <FontAwesomeIcon icon={faSave} size='sm' />
            </div>
            <Tooltip place='top' id='save' />
          </>
        }

      </div>
      </div>
     
      <div className="custom-node__body">
        <textarea
          value={text}
          disabled={(lockedByUsername !== user?.sub)}
          onChange={(e) => { data.text = e.currentTarget.value; setText(data.text); }}
          placeholder={'Source of Risk description'}
          rows={"4"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <Handle style={{ width: '10px', height: '6px', bottom: '-6px' }} type="source" position={Position.Bottom} id={keys[0]} />
    </>
  );
}

export default memo(Hazard);
